<template>
  <section>
    <div class="flex px-10 py-10">
      <div class="w-8/12 mx-2" id="message-pane">
        <div v-if="currentDoc">
          <embed @contextmenu.prevent
                 :src="`https://www.pappers.fr/recherche?q=${currentDoc.domiciliationOrder.siren}#toolbar=0`" width="100%"
                 height="100%" style="height: 100vh" />
        </div>
      </div>

      <aside class="w-4/12 is-3 aside hero is-fullheight px-5" v-if="currentDoc"
             style="overflow-y: scroll; height: 100vh">
        <h1 class="title">
          Numéro {{ currentDoc.domiciliationOrder.id }}
          <a class="sub-link" target="_blank"
             :href="`https://www.pappers.fr/recherche?q=${currentDoc.domiciliationOrder.siren}`">Pappers</a>
        </h1>
        <vs-input v-if="currentDoc" :class="currentDoc.isDiffNomComplet
          ? `w-full mb-4 text-check-invalid`
          : 'w-full mb-4'
        " label="Nom complet:" v-model="currentDoc.nomComplet" type="text" />
        <p v-if="currentDoc">
          <span class="vs-input--label">Papper Nom complet: </span> <br />
          <strong :class="currentDoc.isDiffNomComplet ? `text-check-invalid` : ''">{{ currentDoc.papperNomComplet
          }}</strong>
        </p>
        <hr />
        <vs-input v-if="currentDoc" :class="currentDoc.isDiffCompanyName
          ? `w-full mb-4 text-check-invalid`
          : 'w-full mb-4'
        " label="Nom societe:" v-model="currentDoc.companyName" type="text" />
        <p v-if="currentDoc">
          <span class="vs-input--label">Papper Nom societe: </span><br />
          <strong :class="currentDoc.isDiffCompanyName ? `text-check-invalid` : ''">{{ currentDoc.papperCompanyName
          }}</strong>
        </p>
        <hr />
        <p v-if="currentDoc">
          <span class="vs-input--label">Code Postal: </span>
          <strong :class="currentDoc.isDiffPostalCode ? `text-check-invalid` : ``">{{ currentDoc.postalCode }}</strong>
        </p>
        <p v-if="currentDoc">
          <span class="vs-input--label">Papper Code Postal: </span>
          <strong :class="currentDoc.isDiffPostalCode ? `text-check-invalid` : ``">{{ currentDoc.papperPostalCode
          }}</strong>
        </p>
        <hr />
        <p v-if="currentDoc">
          <span class="vs-input--label">Papper status: </span>
          <strong :class="currentDoc.isDiffStatus ? `text-check-invalid` : ``">{{ currentDoc.papperCompanyStatus
          }}</strong>
        </p>
        <p v-if="currentDoc">
          <span class="vs-input--label">Siren: </span><strong>{{ currentDoc.domiciliationOrder.siren }}</strong>
        </p>
        <div class="my-6">
          <vs-button class="mx-1" color="danger" @click="verified(true)">Conforme</vs-button>
          <vs-button class="mx-1" color="danger" @click="verified(false)">Non conforme</vs-button>
        </div>
        <!-- <div class="my-6">
          <vs-button class="mx-1" color="danger" @click="abandoned()">Radiées</vs-button>
          <vs-button class="mx-1" color="danger" @click="updateStatus(false)">Non diffusables</vs-button>
        </div>
        <vs-input v-if="currentDoc" :class="!nomComplet ? `w-full mb-4 text-check-invalid` : 'w-full mb-4'"
          label="Nom complet - Dirigeant:" v-model="nomComplet" type="text" />
        <vs-input v-if="currentDoc" :class="'w-full mb-4'" label="Nom complet - Dirigeant:" v-model="nomComplet2"
          type="text" />
        <vs-input v-if="currentDoc" :class="'w-full mb-4'" label="Nom complet - Dirigeant:" v-model="nomComplet3"
          type="text" />
        <vs-input v-if="currentDoc" :class="'w-full mb-4'" label="Nom complet - Dirigeant:" v-model="nomComplet4"
          type="text" />
        <vs-input v-if="currentDoc" :class="'w-full mb-4'" label="Nom complet - Dirigeant:" v-model="nomComplet5"
          type="text" />
        <div class="my-6">
          <vs-button class="mx-1" color="danger" @click="dirigeant()">Dirigeant faux</vs-button>
        </div> -->
      </aside>
    </div>
  </section>
</template>

<script>
import { format } from 'date-fns'
import { mapActions } from 'vuex'
export default {
  components: {},
  data() {
    return {
      currentDoc: null,
      currentIndex: null,
      isLoadingDoc: false,
      nomComplet: '',
      nomComplet2: '',
      nomComplet3: '',
      nomComplet4: '',
      nomComplet5: '',
    }
  },
  async mounted() {
    this.loadDoc()
  },
  methods: {
    ...mapActions({
      toggleLoader: 'loader/toggle',
    }),
    async loadDoc() {
      this.toggleLoader({ val: true })
      const endpoint = `${ process.env.VUE_APP_API_URL }api-backend/domiciliation_order_pappers/${this.$route.params.id}`
      const response = await this.$axios.get(endpoint)
      const data = response.data
      this.currentDoc = data
      this.toggleLoader({ val: false })
    },
    async verified(status) {
      this.toggleLoader({ val: true })
      const params = {
        type: 1,
        verify: status ? 1 : 0,
        nomComplet: '', //this.currentDoc.nomComplet,
        nomSociete: '', //this.currentDoc.companyName
      }
      if (status) {
        params['nomComplet'] = this.currentDoc.nomComplet
        params['nomSociete'] = this.currentDoc.companyName
      }
      try {
        const res = await this.$axios.post(
            `${ process.env.VUE_APP_API_URL }api-backend/domiciliation-order-pappers/${this.currentDoc.id
            }:edit`, params
        )
        if (status) {
          this.$axios.post(
           `${ process.env.VUE_APP_API_URL }api-backend/domiciliation-order-pappers/${this.currentDoc.id}:remove`
          )

          this.$axios.post(`${process.env.VUE_APP_API_URL}api-backend/domiciliation-orders/${this.currentDoc.domiciliationOrder.id}/notes`, {
            content: 'Pappers: Controle des dirigeants, activité - pas de changements conforme',
          })
        }
        this.toggleLoader({ val: false })
        const next = res.data ? res.data.next : null
        if (!next) {
          this.$router.push({ name: 'pappers-verify' })
        } else {
          this.currentDoc = next
          this.$router.replace({ params: { id: next.id } })
        }
      } catch {
        this.toggleLoader({ val: false })
      }
    },
    close() {
      this.$router.push({ name: 'pappers-verify' })
    },
    formatDate(date) {
      if (date) {
        return format(new Date(date), 'dd/MM/yyyy')
      }

      return '-'
    },
    async updateStatus(status) {
      this.close()
    },
    async abandoned() {
      try {
        this.toggleLoader({ val: true })
        if (
          window.confirm(
            'Êtes-vous sûr de vouloir mettre cet ordre de domiciliation en page "abandonnés" ?'
          )
        ) {
          const statusRes = await this.$axios.post(
            `${ process.env.VUE_APP_API_URL }api-backend/domiciliation-order-pappers/${this.currentDoc.id}:abandoned`
          )
          const statusRemoveRes = await this.$axios.post(
            `${ process.env.VUE_APP_API_URL }api-backend/domiciliation-order-pappers/${this.currentDoc.id}:remove`
          )
          const nextResponse = await this.$axios.post(
            `${ process.env.VUE_APP_API_URL }api-backend/domiciliation-order-pappers/${this.currentDoc.id}:next?type=1`
          )
          const next = nextResponse && nextResponse.data ? nextResponse.data : []
          if (!next || !next['data'] || !next['data']['length']) {
            this.$router.push({ name: 'pappers-faux' })
          } else {
            this.currentDoc = next['data'][0]
          }
          //this.close();
        }
        this.toggleLoader({ val: false })
      } catch {
        this.toggleLoader({ val: false })
      }
    },
    async dirigeant() {
      try {
        if (!this.nomComplet) {
          this.$vs.notify({
            title: 'Erreur !',
            text: 'Le nom est requis',
            color: 'danger',
          })
          return
        }
        this.toggleLoader({ val: true })
        if (
          window.confirm(
            'Êtes-vous sûr de vouloir mettre cet ordre de domiciliation en page "Dirigeant" ?'
          )
        ) {
          const statusRes = await this.$axios.post(
            `${ process.env.VUE_APP_API_URL }api-backend/pics/add-waiting-validation`,
            {
              orderId: this.currentDoc.domiciliationOrder.id,
              nomComplet: this.nomComplet,
              nomComplet2: this.nomComplet2,
              nomComplet3: this.nomComplet3,
              nomComplet4: this.nomComplet4,
              nomComplet5: this.nomComplet5,
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          const statusRemoveRes = await this.$axios.post(
            `${ process.env.VUE_APP_API_URL }api-backend/domiciliation-order-pappers/${this.currentDoc.id}:remove`
          )
          const nextResponse = await this.$axios.post(
            `${ process.env.VUE_APP_API_URL }api-backend/domiciliation-order-pappers/${this.currentDoc.id}:next?type=1`
          )
          const next = nextResponse && nextResponse.data ? nextResponse.data : []
          if (!next || !next['data'] || !next['data']['length']) {
            this.$router.push({ name: 'pappers-faux' })
          } else {
            this.currentDoc = next['data'][0]
          }
          //this.close();
        }
        this.toggleLoader({ val: false })
      } catch {
        this.toggleLoader({ val: false })
      }
    },
  },
}
</script>
<style lang="scss">
#message-pane {
  img {
    pointer-events: none;
  }
}

.identity-doc-content {
  position: relative;
  overflow: hidden;

  .embed-cover {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    .confidentiel {
      color: red;
      font-size: 50px;
      position: absolute;
      top: 35%;
      left: 15%;
      transform: rotate(-45deg);
    }

    &.embed {
      right: 15px;
    }

    /* Just for demonstration, remove this part */
    opacity: 0.25;
    background-color: transparent;
  }
}

.btn-download {
  color: white !important;
  text-decoration: none;
}

.sub-link {
  font-size: 12px;
}

.text-check-invalid {
  color: rgba(var(--vs-danger), 1) !important;

  strong {
    color: rgba(var(--vs-danger), 1) !important;
  }
}
</style>
